import templateUrl from "emun.salesrep/managergroup-dashboard.htm";
import salesAnalysisURL from "emun.salesrep/sales-analysis-prompt.htm";
import salesrepConfig from "emun.salesrep/salesrep.config";
import basicController from "servicestack/basic.controller.properties";
import $appConfig from "servicestack/config";
import modals from "webmodals/modals";

class ManagerGroupDashboardController {
  constructor(createAutoQuery, $session, $window, $state) {
    basicController(this);
    var map = this;
    let $ctrl = this;
    $ctrl.salesrepConfig = salesrepConfig;
    $ctrl.chartLoaded = false;
    this.productImage = $appConfig.productImage.bind($appConfig);
    var repId = this.repId;
    let options = {
      url: "QuerySalesReps.json?IncludeSalesData=true&Id=" + this.repId,
      pageSize: 15,
      orderBy: "Name",
      autoLoad: true,
      append: false,
      onLoaded: function (args) {
        if (args.total > 0) {
          $ctrl.rep = args.first;
          $ctrl.$state.current.customTitle = $ctrl.rep.name;
        } else {
          $ctrl.rep = { id: repId, name: repId };
          $ctrl.$state.current.customTitle = $ctrl.rep.name;
        }
      },
    };
    $ctrl.goals = {
      month: 0,
      monthPercent: 0,
      quarter: 0,
      quarterPercent: 0,
      year: 0,
      yearPercent: 0,
    };
    this.dailySales = {
      total: 0,
      count: 0,
    };
    this.yesterdaySales = {
      total: 0,
      count: 0,
    };
    this.weekSales = {
      total: 0,
      count: 0,
    };
    this.lastweekSales = {
      total: 0,
      count: 0,
    };
    this.quarterSales = {
      total: 0,
      count: 0,
      percent: 0,
      trend: "neutral",
    };
    this.lastquarterSales = {
      total: 0,
      count: 0,
    };
    this.ytdSales = {
      total: 0,
      count: 0,
      percent: 0,
      trend: "neutral",
    };
    this.lastytdSales = {
      total: 0,
      count: 0,
    };
    this.mtdSales = {
      total: 0,
      count: 0,
      percent: 0,
      trend: "neutral",
    };
    this.lastmtdSales = {
      total: 0,
      count: 0,
    };
    this.query = createAutoQuery(options);
    var addToQueryString = "";

    if ($ctrl.insideSales) {
      if ($ctrl.insideSales === "true") {
        addToQueryString = "&IsInsideSales=true";
      }
    }
    //} else {
    //  addToQueryString = '&IsInsideSales=false';
    //}

    $ctrl.dailySalesQuery = createAutoQuery({
      url:
        "QuerySalesYOYTotals.json?Sum=TotalSalesToday,TotalSalesCountToday,TotalSalesYesterday,TotalSalesCountYesterday,TotalSalesWeekToDate,TotalSalesCountWeekToDate,TotalSalesQuarterToDate,TotalSalesCountQuarterToDate,TotalSalesQuarterToDateLastYear,TotalSalesCountQuarterToDateLastYear,TotalSalesYearToDate,TotalSalesCountYearToDate,TotalSalesYearToDateLastYear,TotalSalesCountYearToDateLastYear,TotalSalesMonthToDate,TotalSalesCountMonthToDate,TotalSalesMonthToDateLastYear,TotalSalesCountMonthToDateLastYear&GroupBy=SalesRepID&managerId=" +
        $ctrl.repId +
        addToQueryString,
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        if (args.total > 0) {
          args.results.forEach(function (res) {
            $ctrl.dailySales.total += res.sumTotalSalesToday;
            $ctrl.dailySales.count += res.sumTotalSalesCountToday;
            $ctrl.yesterdaySales.total += res.sumTotalSalesYesterday;
            $ctrl.yesterdaySales.count += res.sumTotalSalesCountYesterday;
            $ctrl.weekSales.total += res.sumTotalSalesWeekToDate;
            $ctrl.weekSales.count += res.sumTotalSalesCountWeekToDate;
            $ctrl.quarterSales.total += res.sumTotalSalesQuarterToDate;
            $ctrl.quarterSales.count += res.sumTotalSalesCountQuarterToDate;
            $ctrl.lastquarterSales.total +=
              res.sumTotalSalesQuarterToDateLastYear;
            $ctrl.lastquarterSales.count +=
              res.sumTotalSalesCountQuarterToDateLastYear;
            var percent = Math.round(
              ($ctrl.quarterSales.total / $ctrl.lastquarterSales.total) * 100
            );
            if (percent < 100) {
              $ctrl.quarterSales.percent = 100 - percent;
              $ctrl.quarterSales.trend = "down";
            } else if (percent > 100) {
              $ctrl.quarterSales.percent = percent - 100;
              $ctrl.quarterSales.trend = "up";
            } else {
              $ctrl.quarterSales.percent = 100;
              $ctrl.quarterSales.trend = "neutral";
            }
            $ctrl.ytdSales.total += res.sumTotalSalesYearToDate;
            $ctrl.ytdSales.count += res.sumTotalSalesCountYearToDate;
            $ctrl.lastytdSales.total += res.sumTotalSalesYearToDateLastYear;
            $ctrl.lastytdSales.count +=
              res.sumTotalSalesCountYearToDateLastYear;
            percent = Math.round(
              ($ctrl.ytdSales.total / $ctrl.lastytdSales.total) * 100
            );
            if (percent < 100) {
              $ctrl.ytdSales.percent = 100 - percent;
              $ctrl.ytdSales.trend = "down";
            } else if (percent > 100) {
              $ctrl.ytdSales.percent = percent - 100;
              $ctrl.ytdSales.trend = "up";
            } else {
              $ctrl.ytdSales.percent = 100;
              $ctrl.ytdSales.trend = "neutral";
            }
            $ctrl.mtdSales.total += res.sumTotalSalesMonthToDate;
            $ctrl.mtdSales.count += res.sumTotalSalesCountMonthToDate;
            $ctrl.lastmtdSales.total += res.sumTotalSalesMonthToDateLastYear;
            $ctrl.lastmtdSales.count +=
              res.sumTotalSalesCountMonthToDateLastYear;
            percent = Math.round(
              ($ctrl.mtdSales.total / $ctrl.lastmtdSales.total) * 100
            );
            if (percent < 100) {
              $ctrl.mtdSales.percent = 100 - percent;
              $ctrl.mtdSales.trend = "down";
            } else if (percent > 100) {
              $ctrl.mtdSales.percent = percent - 100;
              $ctrl.mtdSales.trend = "up";
            } else {
              $ctrl.mtdSales.percent = 100;
              $ctrl.mtdSales.trend = "neutral";
            }
          });
        }

        if (!$ctrl.insideSales) {
          addToQueryString = "&IsInsideSales=false";
        }
        $ctrl.goalsQuery = createAutoQuery({
          url:
            "QuerySalesRepGoals.json?Sum=SalesGoalThisMonth,SalesGoalThisYear,SalesGoalLastYear,SalesGoalLastMonth,SalesGoalThisQuarter,RepInsideSalesGoalThisMonth,RepInsideSalesGoalThisYear,RepInsideSalesGoalLastYear,RepInsideSalesGoalLastMonth,RepInsideSalesGoalThisQuarter&GroupBy=vendorID&managerId=" +
            $ctrl.repId +
            addToQueryString,
          autoLoad: true,
          pageSize: 1000,
          onLoaded: function (args) {
            if (args.total > 0) {
              args.results.forEach(function (res) {
                if ($ctrl.insideSales) {
                  $ctrl.goals.month += Math.round(
                    res.sumRepInsideSalesGoalThisMonth
                  );
                  $ctrl.goals.quarter += Math.round(
                    res.sumRepInsideSalesGoalThisQuarter
                  );
                  $ctrl.goals.year += Math.round(
                    res.sumRepInsideSalesGoalThisYear
                  );
                } else {
                  $ctrl.goals.month += Math.round(res.sumSalesGoalThisMonth);
                  $ctrl.goals.quarter += Math.round(
                    res.sumSalesGoalThisQuarter
                  );
                  $ctrl.goals.year += Math.round(res.sumSalesGoalThisYear);
                }
              });

              $ctrl.goals.monthPercent = Math.round(
                ($ctrl.mtdSales.total / $ctrl.goals.month) * 100
              );
              $ctrl.goals.quarterPercent = Math.round(
                ($ctrl.quarterSales.total / $ctrl.goals.quarter) * 100
              );
              $ctrl.goals.yearPercent = Math.round(
                ($ctrl.ytdSales.total / $ctrl.goals.year) * 100
              );
            }
          },
        });
      }, ///end of first autoquery
    });
    $ctrl.lastweekSalesQuery = createAutoQuery({
      url:
        "QuerySalesDailyTotals.json?dateRange=LastWeek&Sum=OrderTotal&Count=OrderTotal&GroupBy=SalesRepID&managerId=" +
        $ctrl.repId,
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        if (args.total > 0) {
          args.results.forEach(function (res) {
            $ctrl.lastweekSales.total += Math.round(res.sumOrderTotal);
            $ctrl.lastweekSales.count += res.countOrderTotal;
          });
        }
      },
    });
    this.$session = $session;
    $ctrl.markets = [];
    $ctrl.showCodesQuery = createAutoQuery({
      url: "QueryMarketDates.json",
      autoLoad: true,
      take: 1000,
      onLoaded: function (args) {
        args.results.forEach(function (market) {
          if (
            $ctrl.markets.filter(
              (m) => m.market === market.market && m.year === market.year
            ).length === 0
          ) {
            $ctrl.markets.push(market);
          }
        });
      },
    });
  }
  load() {
    return this.query.load.apply(this.query, arguments);
  }

  runSalesAnalysisReport() {
    let $ctrl1 = this;
    return modals.open({
      templateUrl: salesAnalysisURL,
      controllerAs: "$ctrl",
      controller($scope, $uibModalInstance, $session) {
        let $ctrl = this;
        $ctrl.startOn = moment().subtract(1, "days");
        $ctrl.repId = "";
        //$ctrl.endOn = moment().subtract(1, 'days');
        $ctrl.dismiss = $ctrl.cancel = function () {
          $uibModalInstance.close();
        };
        $ctrl.runReport = function () {
          $uibModalInstance.close();
          let url = $appConfig.resolveServiceUrl(
            "RunSalesAnalysis?startDate=" +
              $ctrl.startOn.format("MM/DD/YYYY") +
              "&repId=" +
              $ctrl.request.SalesRep.id
          );
          return (location.href = url);
        };
      },
      size: "lg",
    }).result;
  }

  runReport(name) {
    const $ctrl = this;
    let url = $appConfig.resolveServiceUrl(
      "" + name + "?ManagerId=" + $ctrl.repId
    );
    return (location.href = url);
  }
}
export default {
  bindings: {
    repId: "@",
    insideSales: "@",
  },
  require: {
    container: "^managerContainer",
  },
  controller: ManagerGroupDashboardController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
